import React,{useEffect, useState} from "react"

import { Row, Col, Card, CardBody, Badge, CardTitle, InputGroup, Label, FormGroup, Button, Modal, Pagination, PaginationItem, PaginationLink } from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import { Link, Redirect, useNavigate } from 'react-router-dom';
import Flatpickr from "react-flatpickr"
import Select from "react-select"
import { connect } from "react-redux";
import * as url from "../../helpers/url_helper"
import { setBreadcrumbItems } from "../../store/actions";
import moment from "moment"
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import Switch from "react-switch"
import { Chrono } from "react-chrono";
import { BarLoader, BounceLoader } from "react-spinners";

const Demandes = (props) => {
  document.title = "Opérations | Interface des opérations";

  const breadcrumbItems = [
    { title: "Lexa", link: "#" },
    { title: "Tables", link: "#" },
    { title: "Responsive Table", link: "#" },
  ]
  const [loadingOps, setLoadingOps] = useState(false);
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [opType, setOpType] = useState("DEFAULT");
  const [agDest, setAgDest] = useState('');
  const [nature, setNature] = useState(null);
  const [emballage, setEmballage] = useState(null);
  const [operations, setOperations] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [currPage, setCurrPage] = useState(0);
  const [status, setStatus] = useState(1);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [totalOps, setTotalOps] = useState(0);
  const [startDate, setStartDate] = useState(moment().subtract(7, "days").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const optionStatus = [ { options: [{label: "Tous les status", value: null}, {label: "En attente", value: 0}, {label: "Confirmé", value: 1}, {label: "En cours", value: 2}, {label: "Livré", value: 3}] } ]
  const handleStartDate= (date)=>{ setStartDate(moment(date[0]).format("YYYY-MM-DD")); }
  const handleEndDate= (date)=>{ setEndDate(moment(date[0]).format("YYYY-MM-DD")); }
  const handleStatus= (event)=>{ setSelectedStatus(event); setStatus(event.value); }
  const [detail, setDetail] = useState(null);
  const [modal_large, setmodal_large] = useState(false)
  const [modal_opera, setmodal_opera] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null); 
  const userJson= JSON.parse(localStorage.getItem("user"));
  const [msgError, setMsgError]= useState("")
  const [msgSuccess, setMsgSuccess]= useState("")
  
  const [numColis, setNumColis]= useState("")
  const navigate = useNavigate();
  const Offsymbol = (props) => {
    return (
      <div
        style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%", fontSize: 12, color: "#fff", paddingRight: 2 }}>
        {" "} NON
      </div>
    )
  }
  
  const handleClick = (key) => {
    setSelectedRow(key); 
  };

  const OnSymbol = () => {
    return (
      <div
        style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%", fontSize: 12, color: "#fff", paddingRight: 2 }}>
        {" "} OUI
      </div>
    )
  }
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  function tog_form_opera() {
    setmodal_large(!modal_large)
    removeBodyCss()
  }
  
  function tog_get_opera() {
    setmodal_opera(!modal_opera)
    removeBodyCss()
  }

  const confirmDemande= ()=> {
    setLoadingConfirm(true)
    fetch(url.API_LIVRAISON_BACKEND+"/demandes/change-state?id="+detail.id+"&state=1", {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { 
      if (responseJson.status==200) { 
        setOperations(prevOpera => 
          prevOpera.map(opera => 
            opera.id === detail.id
              ? { ...opera, stat: 1}
              : opera
          )
        );
        setLoadingConfirm(false)
        tog_get_opera()
    } else { setLoadingConfirm(false); tog_get_opera(); alert(responseJson.message) }
    }) .catch((error) => { setLoadingConfirm(false); tog_get_opera(); });
  };
  
  const loadOperations=(page)=> {
    setLoadingOps(true)
    fetch(url.API_LIVRAISON_BACKEND+"/demandes?start="+startDate+"&end="+endDate+"&page="+page+(status==null ? (""): "&stat="+status) , {
      method: 'GET', headers: { Accept: 'application/json', 'Content-Type': 'application/json' } })
    .then((response) => response.json())
    .then((responseJson) => { console.log(responseJson.data);
      if (responseJson.status==200) { 
        setOperations(responseJson.data.items)
        setTotalOps(responseJson.data.total)
        setTotalPage(responseJson.data.total_pages, 30)
        setCurrPage(responseJson.data.page, 30)
        setLoadingOps(false)
    } else { setLoadingOps(false)  }
    }) .catch((error) => {  setLoadingOps(false) });
  };
  
  const getOperation=(item)=> {
    let timeLine=[];
    timeLine= [
      ...timeLine,
      ...item.operation.actions.map(ite=>(
        {
          title: ite.nom,
          cardTitle: ite.nom,
          cardSubtitle: "Ue Digital",
          cardDetailedText: moment(ite.create).format("DD-MM-YYYY HH:mm:SS")
        }
      ))
    ]
    return (
        <Row>
          <Col xl="7">
            <div className="table-rep-plugin">
              <div className="table-responsive mb-0" data-pattern="priority-columns">
              <Table id="tech-companies-1" className="table table-striped table-bordered">
                <Tbody>
                  <Tr><Td>Agence départ</Td><Td><strong>{item.operation.agexp.nom}</strong></Td></Tr>
                  <Tr><Td>Agence Bénéficiaire</Td><Td><strong>{item.operation.agdest.nom}</strong></Td></Tr>
                  <Tr><Td>Expéditeur</Td><Td><strong>{item.operation.exp} ({item.operation.phonexp})</strong></Td></Tr>
                  <Tr><Td>Bénéficiaire</Td><Td><strong>{item.operation.dest} ({item.operation.destphone})</strong></Td></Tr>
                  <Tr><Td>Code du colis</Td><Td><strong>{item.operation.code}</strong></Td></Tr>
                  <Tr><Td>Emballage</Td><Td><strong>{item.operation.detail[0].embal.libelle}</strong></Td></Tr>
                  <Tr><Td>Nature</Td><Td><strong>{item.operation.detail[0].nature.libelle}</strong></Td></Tr>
                  <Tr><Td>Valeur</Td><Td><strong>{item.operation.valeur} FCFA</strong></Td></Tr>
                  <Tr><Td>Frais d'expédition</Td><Td><strong>{item.operation.frais} FCFA</strong></Td></Tr>
                  <Tr><Td>Client Livraison</Td><Td><strong>{item.clt.nom} {item.clt.phone}</strong></Td></Tr>
                  <Tr><Td>Adresse Livraison</Td><Td><strong>{item.zone.commune.nom}, {item.zone.nom}, {item.adress}</strong></Td></Tr>
                  <Tr><Td>Frais de livraison</Td><Td><strong>{item.zone.tarif} FCFA</strong></Td></Tr>
                  <Tr><Td>Date demande</Td><Td><strong>{moment(item.create).format("DD-MM-YY HH:mm:ss")}</strong></Td></Tr>
                </Tbody>
              </Table>
              </div>
            </div>
          </Col>
          <Col xl="5" style={{ height: "500px", overflow: "auto" }}>
            <Chrono disableToolbar={true} mode="VERTICAL_ALTERNATING" cardHeight={80} fontSizes={{ title: "9pt", cardTitle: "9pt", cardSubtitle: "7pt", cardDetailedText: "5pt"}} cardWidth={180} items={timeLine} />
          </Col>
        </Row>);};
  
  useEffect(() => {
    props.setBreadcrumbItems('Liste des demandes')
    loadOperations(0)
  }, [])
  
  
  return (
    <React.Fragment>
      <Modal size="xl" isOpen={modal_opera} toggle={() => { tog_get_opera() }}>
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myLargeModalLabel">Consultation détails demande</h5>
         
          {detail && detail.stat==0 ? 
          (<Col xl="3">
            <Button className="btn btn-lg btn-primary" tag="button" onClick={()=>{confirmDemande()}}>
             CONFIRMER LA DEMANDE 
            </Button>
            <span>{loadingConfirm ? (<BounceLoader size={30} color="green"/>): null}</span>
          </Col>): (null)}
        </div>
          {detail && getOperation(detail)}
      </Modal>
        
      <Row>
        <Col xl="3">
          <FormGroup className="mb-4">
            <Label>Début</Label>
            <InputGroup>
              
              <Flatpickr
                className="form-control d-block"
                placeholder="Date début"
                value={startDate}
                onChange={handleStartDate}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d"
                }}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        <Col xl="3">
          <FormGroup className="mb-4">
            <Label>Fin</Label>
            <InputGroup>
              <Flatpickr
                className="form-control d-block"
                placeholder="Date Fin"
                value={endDate}
                onChange={handleEndDate}
                options={{
                  altInput: true,
                  altFormat: "Y-m-d",
                  dateFormat: "Y-m-d"
                }}
              />
            </InputGroup>
          </FormGroup>
        </Col>
        
        <Col lg="3">
          <div className="mb-3">
            <Label>Status</Label>
            <Select
              value={selectedStatus}
              onChange={handleStatus}
              options={optionStatus}
              classNamePrefix="select2-selection"
            />
          </div>
        </Col>
        <Col lg="3">
          <div className="mt-3">
            <Button type="button" style={{ width: "100%" }} onClick={()=>{loadOperations(0)}} color="primary" data-toggle="Button" size="lg" className="mt-2 waves-effect waves-light">Recharger</Button>
          </div>
        </Col>
      </Row>
     <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="h4">{totalOps} élément(s) </CardTitle>
              <Card>
                {totalPage ==0 ? ( null): totalPage>=25 ? (<nav aria-label="...">
                  <Pagination>
                      {Array.from({ length: 25}, (_, index) => (
                      <PaginationItem active={index==currPage} ><PaginationLink  onClick={()=>loadOperations(index)}>{index+1}</PaginationLink></PaginationItem>
                      ))}
                      <PaginationItem><PaginationLink onClick={()=>loadOperations(totalPage-1)}>......{totalPage-1}</PaginationLink></PaginationItem>
                      <PaginationItem><PaginationLink onClick={()=>loadOperations(currPage+1)}>Suivant</PaginationLink></PaginationItem>
                  </Pagination>
                </nav>): 
                (<nav aria-label="...">
                  <Pagination>
                      {Array.from({ length: totalPage}, (_, index) => (
                      <PaginationItem active={index==currPage} ><PaginationLink  onClick={()=>loadOperations(index)}>{index+1}</PaginationLink></PaginationItem>
                      ))}
                      <PaginationItem><PaginationLink onClick={()=>loadOperations(currPage+1)}>Suivant</PaginationLink></PaginationItem>
                  </Pagination>
                </nav>)}
              </Card>

              <div className="table-rep-plugin">
                <div
                  className="table-responsive mb-0"
                  data-pattern="priority-columns"
                >
                  <div>
                    {loadingOps ? (<BarLoader width={"100%"} height={6}/>): null}
                  </div>
                  <Table
                    id="tech-companies-1"
                    className="table table-striped table-bordered"
                  >
                    <Thead>
                      <Tr>
                        <Th>Date</Th>
                        <Th data-priority="1">Colis concerné</Th>
                        <Th data-priority="3">Itinéraire</Th>
                        <Th data-priority="3">Client</Th>
                        <Th data-priority="1">Adresse de livraison</Th>
                        <Th data-priority="3">Tarif</Th>
                        <Th data-priority="3">Status</Th>
                        <Th data-priority="6">Détail</Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {operations.map((item, key)=>(
                      <Tr>
                        <Th>
                          <strong>{moment(item.create).format("DD-MM-YY HH:mm:ss")}</strong>
                        </Th>
                        <Td><strong>{item.operation.code} </strong> <br/>
                          {item.operation.detail[0].nature.libelle}, {item.operation.detail[0].embal.libelle}
                        </Td>
                        <Td><strong>{item.operation.agexp.nom}</strong> vers <strong>{item.operation.agdest.nom}</strong></Td>
                        <Td>{item.clt!=null ? (item.clt.nom+" "+item.clt.phone): null}</Td>
                        <Td>{item.zone.commune.nom}, {item.zone.nom}, {item.adress}</Td>
                        <Td>{item.zone.tarif} FCFA</Td>
                        <Td style={{ fontSize: 15 }}>
                          {item.stat==0 ? (<Badge className={"rounded-pill bg-danger"}>En attente</Badge>):
                          item.stat==1 ? (<Badge className={"rounded-pill bg-warning"}>Confirmé</Badge>):
                          item.stat==2 ? (<Badge className={"rounded-pill bg-info"}>En cours</Badge>):
                          (<Badge className={"rounded-pill bg-success"}>Livré</Badge>)
                          }
                        </Td>
                        <Td><Button onClick={()=>{setDetail(item); setTimeout(() => { tog_get_opera() }, 100);}} ><i className="fa fa-eye"></i></Button></Td>
                      </Tr>
                      ))}
                      
                    </Tbody>
                  </Table>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

    </React.Fragment>
  )
}
export default connect(null, { setBreadcrumbItems })(Demandes)